import { createSelector } from "reselect";

export const Types = {
  GET_REQUEST: "multipliers/GET_REQUEST",
  GET_SUCCESS: "multipliers/GET_SUCCESS",
  GET_FAILURE: "multipliers/GET_FAILURE",

  GET_LIST_REQUEST: "multipliers/GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "multipliers/GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "multipliers/GET_LIST_FAILURE",

  CREATE_REQUEST: "multipliers/CREATE_REQUEST",
  CREATE_SUCCESS: "multipliers/CREATE_SUCCESS",
  CREATE_FAILURE: "multipliers/CREATE_FAILURE",

  UPDATE_REQUEST: "multipliers/UPDATE_REQUEST",
  UPDATE_SUCCESS: "multipliers/UPDATE_SUCCESS",
  UPDATE_FAILURE: "multipliers/UPDATE_FAILURE",

  DELETE_REQUEST: "multipliers/DELETE_REQUEST",
  DELETE_SUCCESS: "multipliers/DELETE_SUCCESS",
  DELETE_FAILURE: "multipliers/DELETE_FAILURE",

  GET_CATEGORIES_REQUEST: "multipliers/GET_CATERGORIS_REQUEST",
  GET_CATEGORIES_SUCCESS: "multipliers/GET_CATEGORIES_SUCCESS",
  GET_CATEGORIES_FAILURE: "multipliers/GET_CATEGORIES_FAILURE",

  GET_CHANNELS_REQUEST: "multipliers/GET_CHANNELS_REQUEST",
  GET_CHANNELS_SUCCESS: "multipliers/GET_CHANNELS_SUCCESS",
  GET_CHANNELS_FAILURE: "multipliers/GET_CHANNELS_FAILURE",

  GET_REGIONS_REQUEST: "multipliers/GET_REGIONS_REQUEST",
  GET_REGIONS_SUCCESS: "multipliers/GET_REGIONS_SUCCESS",
  GET_REGIONS_FAILURE: "multipliers/GET_REGIONS_FAILURE",

  GET_STORES_REQUEST: "multipliers/GET_STORES_REQUEST",
  GET_STORES_SUCCESS: "multipliers/GET_STORES_SUCCESS",
  GET_STORES_FAILURE: "multipliers/GET_STORES_FAILURE",

  GET_PRODUCT_TYPES_REQUEST: "multipliers/GET_PRODUCT_TYPES_REQUEST",
  GET_PRODUCT_TYPES_SUCCESS: "multipliers/GET_PRODUCT_TYPES_SUCCESS",
  GET_PRODUCT_TYPES_FAILURE: "multipliers/GET_PRODUCT_TYPES_FAILURE",

  GET_SECTIONS_REQUEST: "multipliers/GET_SECTIONS_REQUEST",
  GET_SECTIONS_SUCCESS: "multipliers/GET_SECTIONS_SUCCESS",
  GET_SECTIONS_FAILURE: "multipliers/GET_SECTIONS_FAILURE",

  GET_SUB_SECTIONS_REQUEST: "multipliers/GET_SUB_SECTIONS_REQUEST",
  GET_SUB_SECTIONS_SUCCESS: "multipliers/GET_SUB_SECTIONS_SUCCESS",
  GET_SUB_SECTIONS_FAILURE: "multipliers/GET_SUB_SECTIONS_FAILURE",

  GET_PRODUCTS_REQUEST: "multipliers/GET_PRODUCTS_REQUEST",
  GET_PRODUCTS_SUCCESS: "multipliers/GET_PRODUCTS_SUCCESS",
  GET_PRODUCTS_FAILURE: "multipliers/GET_PRODUCTS_FAILURE",

  GET_PASSIONS_REQUEST: "multipliers/GET_PASSIONS_REQUEST",
  GET_PASSIONS_SUCCESS: "multipliers/GET_PASSIONS_SUCCESS",
  GET_PASSIONS_FAILURE: "multipliers/GET_PASSIONS_FAILURE",

  GET_SELLERS_REQUEST: "multipliers/GET_SELLERS_REQUEST",
  GET_SELLERS_SUCCESS: "multipliers/GET_SELLERS_SUCCESS",
  GET_SELLERS_FAILURE: "multipliers/GET_SELLERS_FAILURE",

  GET_TYPES_REQUEST: "multipliers/GET_TYPES_REQUEST",
  GET_TYPES_SUCCESS: "multipliers/GET_TYPES_SUCCESS",
  GET_TYPES_FAILURE: "multipliers/GET_TYPES_FAILURE",

  SEARCH_REQUEST: "multipliers/SEARCH_REQUEST",
  SEARCH_SUCCESS: "multipliers/SEARCH_SUCCESS",
  SEARCH_FAILURE: "multipliers/SEARCH_FAILURE",

  APPROVE_REQUEST: "multipliers/APPROVE_REQUEST",
  APPROVE_SUCCESS: "multipliers/APPROVE_SUCCESS",
  APPROVE_FAILURE: "multipliers/APPROVE_FAILURE",

  REPPROVE_REQUEST: "multipliers/REPPROVE_REQUEST",
  REPPROVE_SUCCESS: "multipliers/REPPROVE_SUCCESS",
  REPPROVE_FAILURE: "multipliers/REPPROVE_FAILURE",

  GET_PLANS_REQUEST: "benefitsTypes/GET_PLANS_REQUEST",
  GET_PLANS_SUCCESS: "benefitsTypes/GET_PLANS_SUCCESS",
  GET_PLANS_FAILURE: "benefitsTypes/GET_PLANS_FAILURE",
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  delete: {
    loading: false,
  },

  plans: {
    data: [],
    loading: false,
  },

  channels: {
    data: [],
    loading: true,
  },

  regions: {
    data: [],
    loading: true,
  },

  stores: {
    data: [],
    loading: true,
  },

  categories: {
    data: [],
    loading: true,
  },

  productTypes: {
    data: [],
    loading: true,
  },

  sections: {
    data: [],
    loading: true,
  },

  subSections: {
    data: [],
    loading: true,
  },

  products: {
    data: [],
    loading: true,
  },

  passions: {
    data: [],
    loading: true,
  },

  sellers: {
    data: [],
    loading: true,
  },

  types: {
    data: [],
    loading: true,
  },

  search: {
    data: [],
    loading: false,
  },

  approve: {
    loading: false,
  },

  repprove: {
    loading: false,
  },
};

export default function multipliers(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.multiplier.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.multipliers.data,
        page: action.payload.multipliers.meta.current_page,
        totals: action.payload.multipliers.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.GET_CATEGORIES_REQUEST:
      return {
        ...state,
        categories: {
          ...state.categories,
          loading: true,
        },
      };
    case Types.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: {
          ...state.categories,
          loading: false,
          data: action.payload.categories.data,
        },
      };
    case Types.GET_CATEGORIES_FAILURE:
      return {
        ...state,
        categories: {
          ...state.categories,
          loading: false,
        },
      };
    case Types.GET_CHANNELS_REQUEST:
      return {
        ...state,
        channels: {
          ...state.channels,
          loading: true,
        },
      };
    case Types.GET_CHANNELS_SUCCESS:
      return {
        ...state,
        channels: {
          ...state.channels,
          loading: false,
          data: action.payload.channels.data,
        },
      };
    case Types.GET_CHANNELS_FAILURE:
      return {
        ...state,
        channels: {
          ...state.channels,
          loading: false,
        },
      };
    case Types.GET_REGIONS_REQUEST:
      return {
        ...state,
        regions: {
          ...state.regions,
          loading: true,
        },
      };
    case Types.GET_REGIONS_SUCCESS:
      return {
        ...state,
        regions: {
          ...state.regions,
          loading: false,
          data: action.payload.regions.data,
        },
      };
    case Types.GET_REGIONS_FAILURE:
      return {
        ...state,
        regions: {
          ...state.regions,
          loading: false,
        },
      };
    case Types.GET_STORES_REQUEST:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: true,
        },
      };
    case Types.GET_STORES_SUCCESS:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: false,
          data: action.payload.stores.data,
        },
      };
    case Types.GET_STORES_FAILURE:
      return {
        ...state,
        stores: {
          ...state.stores,
          loading: false,
        },
      };
    case Types.GET_PRODUCT_TYPES_REQUEST:
      return {
        ...state,
        productTypes: {
          ...state.productTypes,
          loading: true,
        },
      };
    case Types.GET_PRODUCT_TYPES_SUCCESS:
      return {
        ...state,
        productTypes: {
          ...state.productTypes,
          loading: false,
          data: action.payload.productTypes.data,
        },
      };
    case Types.GET_PRODUCT_TYPES_FAILURE:
      return {
        ...state,
        productTypes: {
          ...state.productTypes,
          loading: false,
        },
      };
    case Types.GET_SECTIONS_REQUEST:
      return {
        ...state,
        sections: {
          ...state.sections,
          loading: true,
        },
      };
    case Types.GET_SECTIONS_SUCCESS:
      return {
        ...state,
        sections: {
          ...state.sections,
          loading: false,
          data: action.payload.sections.data,
        },
      };
    case Types.GET_SECTIONS_FAILURE:
      return {
        ...state,
        sections: {
          ...state.sections,
          loading: false,
        },
      };
    case Types.GET_SUB_SECTIONS_REQUEST:
      return {
        ...state,
        subSections: {
          ...state.subSections,
          loading: true,
        },
      };
    case Types.GET_SUB_SECTIONS_SUCCESS:
      return {
        ...state,
        subSections: {
          ...state.subSections,
          loading: false,
          data: action.payload.subSections.data,
        },
      };
    case Types.GET_SUB_SECTIONS_FAILURE:
      return {
        ...state,
        subSections: {
          ...state.subSections,
          loading: false,
        },
      };
    case Types.GET_PRODUCTS_REQUEST:
      return {
        ...state,
        products: {
          ...state.products,
          loading: true,
        },
      };
    case Types.GET_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: {
          ...state.products,
          loading: false,
          data: action.payload.products.data,
        },
      };
    case Types.GET_PRODUCTS_FAILURE:
      return {
        ...state,
        products: {
          ...state.products,
          loading: false,
        },
      };
    case Types.GET_PASSIONS_REQUEST:
      return {
        ...state,
        passions: {
          ...state.passions,
          loading: true,
        },
      };
    case Types.GET_PASSIONS_SUCCESS:
      return {
        ...state,
        passions: {
          ...state.passions,
          loading: false,
          data: action.payload.passions.data,
        },
      };
    case Types.GET_PASSIONS_FAILURE:
      return {
        ...state,
        passions: {
          ...state.passions,
          loading: false,
        },
      };
    case Types.GET_SELLERS_REQUEST:
      return {
        ...state,
        sellers: {
          ...state.sellers,
          loading: true,
        },
      };
    case Types.GET_SELLERS_SUCCESS:
      return {
        ...state,
        sellers: {
          ...state.sellers,
          loading: false,
          data: action.payload.sellers.data,
        },
      };
    case Types.GET_SELLERS_FAILURE:
      return {
        ...state,
        sellers: {
          ...state.sellers,
          loading: false,
        },
      };
    case Types.GET_TYPES_REQUEST:
      return {
        ...state,
        types: {
          ...state.types,
          loading: true,
        },
      };
    case Types.GET_TYPES_SUCCESS:
      return {
        ...state,
        types: {
          ...state.types,
          loading: false,
          data: action.payload.types.data,
        },
      };
    case Types.GET_TYPES_FAILURE:
      return {
        ...state,
        types: {
          ...state.types,
          loading: false,
        },
      };
    case Types.SEARCH_REQUEST:
      return {
        ...state,
        search: {
          ...state.search,
          loading: true,
        },
      };
    case Types.SEARCH_SUCCESS:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
          data: action.payload.multipliers.data,
        },
      };
    case Types.SEARCH_FAILURE:
      return {
        ...state,
        search: {
          ...state.search,
          loading: false,
        },
      };
    case Types.APPROVE_REQUEST:
      return {
        ...state,
        approve: {
          ...state.approve,
          loading: true,
        },
      };
    case Types.APPROVE_SUCCESS:
    case Types.APPROVE_FAILURE:
      return {
        ...state,
        approve: {
          ...state.approve,
          loading: false,
        },
      };
    case Types.REPPROVE_REQUEST:
      return {
        ...state,
        repprove: {
          ...state.repprove,
          loading: true,
        },
      };
    case Types.REPPROVE_SUCCESS:
    case Types.REPPROVE_FAILURE:
      return {
        ...state,
        repprove: {
          ...state.repprove,
          loading: false,
        },
      };
    case Types.GET_PLANS_REQUEST:
      return {
        ...state,
        plans: {
          ...state.plans,
          loading: true,
        },
      };
    case Types.GET_PLANS_SUCCESS:
      return {
        ...state,
        plans: {
          ...state.plans,
          data: action.payload.plans.data,
          loading: false,
        },
      };
    case Types.GET_PLANS_FAILURE:
      return {
        ...state,
        plans: {
          ...state.plans,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getMultiplierRequest: (id) => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getMultiplierSuccess: (multiplier) => ({
    type: Types.GET_SUCCESS,
    payload: { multiplier },
  }),

  getMultiplierFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getMultipliersRequest: (page = 1) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getMultipliersSuccess: (multipliers) => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { multipliers },
  }),

  getMultipliersFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createMultiplierRequest: (data) => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createMultiplierSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createMultiplierFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateMultiplierRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateMultiplierSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateMultiplierFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  deleteMultiplierRequest: (id) => ({
    type: Types.DELETE_REQUEST,
    payload: { id },
  }),

  deleteMultiplierSuccess: () => ({
    type: Types.DELETE_SUCCESS,
  }),

  deletemultiplierFailure: () => ({
    type: Types.DELETE_FAILURE,
  }),

  getMultiplierCategoriesRequest: (query = "") => ({
    type: Types.GET_CATEGORIES_REQUEST,
    payload: { query },
  }),

  getMultiplierCategoriesSuccess: (categories) => ({
    type: Types.GET_CATEGORIES_SUCCESS,
    payload: { categories },
  }),

  getMultiplierCategoriesFailure: () => ({
    type: Types.GET_CATEGORIES_FAILURE,
  }),

  getMultiplierChannelsRequest: (query = "") => ({
    type: Types.GET_CHANNELS_REQUEST,
    payload: { query },
  }),

  getMultiplierChannelsSuccess: (channels) => ({
    type: Types.GET_CHANNELS_SUCCESS,
    payload: { channels },
  }),

  getMultiplierChannelsFailure: () => ({
    type: Types.GET_CHANNELS_FAILURE,
  }),

  getMultiplierRegionsRequest: (query = "") => ({
    type: Types.GET_REGIONS_REQUEST,
    payload: { query },
  }),

  getMultiplierRegionsSuccess: (regions) => ({
    type: Types.GET_REGIONS_SUCCESS,
    payload: { regions },
  }),

  getMultiplierRegionsFailure: () => ({
    type: Types.GET_REGIONS_FAILURE,
  }),

  getMultiplierStoresRequest: (query = "", region = null) => ({
    type: Types.GET_STORES_REQUEST,
    payload: { query, region },
  }),

  getMultiplierStoresSuccess: (stores) => ({
    type: Types.GET_STORES_SUCCESS,
    payload: { stores },
  }),

  getMultiplierStoresFailure: () => ({
    type: Types.GET_STORES_FAILURE,
  }),

  getMultiplierProductTypesRequest: (query = "") => ({
    type: Types.GET_PRODUCT_TYPES_REQUEST,
    payload: { query },
  }),

  getMultiplierProductTypesSuccess: (productTypes) => ({
    type: Types.GET_PRODUCT_TYPES_SUCCESS,
    payload: { productTypes },
  }),

  getMultiplierProductTypesFailure: () => ({
    type: Types.GET_PRODUCT_TYPES_FAILURE,
  }),

  getMultiplierSectionsRequest: (query = "") => ({
    type: Types.GET_SECTIONS_REQUEST,
    payload: { query },
  }),

  getMultiplierSectionsSuccess: (sections) => ({
    type: Types.GET_SECTIONS_SUCCESS,
    payload: { sections },
  }),

  getMultiplierSectionsFailure: () => ({
    type: Types.GET_SECTIONS_FAILURE,
  }),

  getMultiplierSubSectionsRequest: (query = "", section = null) => ({
    type: Types.GET_SUB_SECTIONS_REQUEST,
    payload: { query, section },
  }),

  getMultiplierSubSectionsSuccess: (subSections) => ({
    type: Types.GET_SUB_SECTIONS_SUCCESS,
    payload: { subSections },
  }),

  getMultiplierSubSectionsFailure: () => ({
    type: Types.GET_SUB_SECTIONS_FAILURE,
  }),

  getMultiplierProductsRequest: (query = "") => ({
    type: Types.GET_PRODUCTS_REQUEST,
    payload: { query },
  }),

  getMultiplierProductsSuccess: (products) => ({
    type: Types.GET_PRODUCTS_SUCCESS,
    payload: { products },
  }),

  getMultiplierProductsFailure: () => ({
    type: Types.GET_PRODUCTS_FAILURE,
  }),

  getMultiplierPassionsRequest: (query = "") => ({
    type: Types.GET_PASSIONS_REQUEST,
    payload: { query },
  }),

  getMultiplierPassionsSuccess: (passions) => ({
    type: Types.GET_PASSIONS_SUCCESS,
    payload: { passions },
  }),

  getMultiplierPassionsFailure: () => ({
    type: Types.GET_PASSIONS_FAILURE,
  }),

  getMultiplierSellersRequest: (query = "") => ({
    type: Types.GET_SELLERS_REQUEST,
    payload: { query },
  }),

  getMultiplierSellersSuccess: (sellers) => ({
    type: Types.GET_SELLERS_SUCCESS,
    payload: { sellers },
  }),

  getMultiplierSellersFailure: () => ({
    type: Types.GET_SELLERS_FAILURE,
  }),

  getMultiplierTypesRequest: (query = "") => ({
    type: Types.GET_TYPES_REQUEST,
    payload: { query },
  }),

  getMultiplierTypesSuccess: (types) => ({
    type: Types.GET_TYPES_SUCCESS,
    payload: { types },
  }),

  getMultiplierTypesFailure: () => ({
    type: Types.GET_TYPES_FAILURE,
  }),

  searchMultipliersRequest: (query = "", app_only = "") => ({
    type: Types.SEARCH_REQUEST,
    payload: { query, app_only },
  }),

  searchMultipliersSuccess: (multipliers) => ({
    type: Types.SEARCH_SUCCESS,
    payload: { multipliers },
  }),

  searchMultipliersFailure: () => ({
    type: Types.SEARCH_FAILURE,
  }),

  approveMultiplierRequest: (id) => ({
    type: Types.APPROVE_REQUEST,
    payload: { id },
  }),

  approveMultiplierSuccess: () => ({
    type: Types.APPROVE_SUCCESS,
  }),

  approveMultiplierFailure: () => ({
    type: Types.APPROVE_FAILURE,
  }),

  repproveMultiplierRequest: (id, data) => ({
    type: Types.REPPROVE_REQUEST,
    payload: { id, data },
  }),

  repproveMultiplierSuccess: () => ({
    type: Types.REPPROVE_SUCCESS,
  }),

  repproveMultiplierFailure: () => ({
    type: Types.REPPROVE_FAILURE,
  }),

  getMultiplierPlansRequest: () => ({
    type: Types.GET_PLANS_REQUEST,
  }),

  getMultiplierPlansSuccess: (plans) => ({
    type: Types.GET_PLANS_SUCCESS,
    payload: { plans },
  }),

  getMultiplierPlansFailure: () => ({
    type: Types.GET_PLANS_FAILURE,
  }),
};

const getStatus = (benefit) => {
  switch (benefit.attributes.status) {
    case "approved":
      return { label: "Aprovado", className: "label-active" };
    case "reproved":
      return { label: "Reprovado", className: "label-inactive" };
    case "processing":
      return { label: "Processando", className: "label-processing" };
    case "active":
      return { label: "Ativado", className: "label-active" };
    case "failed":
      return { label: "Falho", className: "label-inactive" };
    case "expired":
      return { label: "Expirado", className: "label-inactive" };
    default:
      return { label: "Pendente", className: "label-pendent" };
  }
};

export const Selectors = {
  multipliers: createSelector(
    (state) => state,
    (multipliers) =>
      multipliers.map((multiplier) => ({
        ...multiplier,
        attributes: {
          ...multiplier.attributes,
          status: getStatus(multiplier),
        },
      }))
  ),

  categories: createSelector(
    (state) => state,
    (categories) =>
      categories.map((category) => ({
        value: category.id,
        label: category.attributes.title,
      }))
  ),

  channels: createSelector(
    (state) => state,
    (channels) =>
      channels.map((channel) => ({
        value: channel.id,
        label: channel.attributes.name,
      }))
  ),

  regions: createSelector(
    (state) => state,
    (regions) =>
      regions.map((region) => ({
        value: region.id,
        label: region.attributes.name,
      }))
  ),

  stores: createSelector(
    (state) => state,
    (stores) =>
      stores.map((store) => ({
        value: store.id,
        label: store.attributes.name,
      }))
  ),

  productTypes: createSelector(
    (state) => state,
    (productTypes) =>
      productTypes.map((productType) => ({
        value: productType.id,
        label: productType.attributes.name,
        external_id: productType.attributes.external_id,
      }))
  ),

  sections: createSelector(
    (state) => state,
    (sections) =>
      sections.map((section) => ({
        value: section.id,
        label: section.attributes.name,
        external_id: section.attributes.external_id,
      }))
  ),

  subSections: createSelector(
    (state) => state,
    (subSections) =>
      subSections.map((subSection) => ({
        value: subSection.id,
        label: subSection.attributes.name,
        external_id: subSection.attributes.external_id,
        subSection,
      }))
  ),

  products: createSelector(
    (state) => state,
    (products) =>
      products.map((product) => ({
        value: product.id,
        label: `${product.attributes.sku} (${product.attributes.name})`,
        external_id: product.attributes.external_id,
        sku: product.attributes.sku,
      }))
  ),

  passions: createSelector(
    (state) => state,
    (passions) =>
      passions.map((passion) => ({
        value: passion.id,
        label: passion.attributes.title,
      }))
  ),

  sellers: createSelector(
    (state) => state,
    (sellers) =>
      sellers.map((seller) => ({
        value: seller.id,
        label:
          seller.attributes &&
          seller.attributes.extra_data &&
          seller.attributes.extra_data.message_content
            ? seller.attributes.extra_data.message_content.SHOP_NAME
            : "Não identificado",
      }))
  ),

  types: createSelector(
    (state) => state,
    (types) =>
      types.map((type) => ({
        value: type.id,
        label: type.attributes.title,
      }))
  ),

  options: createSelector(
    (state) => state,
    (multipliers) =>
      multipliers.map((multiplier) => ({
        value: multiplier.id,
        label: multiplier.attributes.title,
      }))
  ),

  plans: createSelector(
    (state) => state,
    (plans) =>
      plans.map((plan) => ({ value: plan.id, label: plan.attributes.name }))
  ),
};
